import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';
import { DatabaseCacheService } from '../cache/database-cache.service';

@Injectable()
export class DuplicateCheckService {

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    private common: DatabaseCacheService
  ) { }

  DuplicateCheck(signInName, sectionGroupName, sectionName) {

    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    var headers = new HttpHeaders({'Content-Type': 'application/json'})
      .set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    var params = new HttpParams();

    if (signInName != null){
      params = params.set("signInNames", signInName);
    }
    if (sectionGroupName != null){
      params = params.set("sectionGroupNames", sectionGroupName);
    }
    if (sectionName != null){
      params = params.set("sectionNames", sectionName);
    }

    

    return this.httpClient.get(`${apiConfig.uri}/DuplicateCheck`, { headers: headers, params : params });
  }
}
